import React, { memo, Suspense } from "react";
import styles from "./Index.module.less";
import HotInquiry from "./HotInquiry"
import loadable from '@loadable/component'

const NewCarRelease = loadable(() => import("./NewCarRelease"));
const SalesRank = loadable(() => import("./SalesRank"));
const NetFriendHotSearch = loadable(() => import("./NetFriendHotSearch"));
const HotArticle = loadable(() => import("./HotArticle"));


interface IProps {
  activityInfo?: string;
}

const List = React.memo((props: IProps) => {
  return (
    <>
      {/* HotInquiry的判断如有补充需同步到CarList */}
      {["modelIndex", "modelEVSearch"].includes(window.PAGE_NAME) && !window.HAS_CONDITION && <HotInquiry />}
      {["modelIndex"].includes(window.PAGE_NAME) && (
        <>
          <div id='tcCheckCar' className={styles["tcCheckCar"]}></div>
          <NewCarRelease />
          <SalesRank />
          <NetFriendHotSearch />
          <HotArticle />
        </>
      )}
    </>
  );
});

export default memo(List);
